import React from 'react';

import { Avatar } from '@material-ui/core';

import styles from './InvitedMemberAvatar.module.scss';

export interface InvitedMemberAvatarProps {
	name: string;
}

export const InvitedMemberAvatar = ({ name }: InvitedMemberAvatarProps) => {
	return (
		<Avatar alt={name} classes={{ root: styles['avatar'] }}>
			?
		</Avatar>
	);
};
